import { connect } from 'react-redux';
import TimingHandler from './TimingHandler';

export default connect(state => state.TimingState)(TimingHandler);



/** WEBPACK FOOTER **
 ** ./core_components/TimingHandler/TimingHandlerContainer.js
 **/